import { Container } from "@/components/pieces/bootstrap";
import { StyledTitle } from "@/components/pieces/marketing/Titles";
import { PUBLIC_CONTENT_MAX_WIDTH } from "@/css/constants";

import { CoachingCallout } from "./CoachingCallout";
import { LearningPlatformCallout } from "./LearningPlatformCallout";
import { RoleplaysCallout } from "./RoleplaysCallout";
import { SecurityCallout } from "./SecurityCallout";

export function PlatformAreas() {
  return (
    <div className="py-20">
      <Container maxWidth={PUBLIC_CONTENT_MAX_WIDTH}>
        <StyledTitle>One platform, endless possibilities</StyledTitle>
        <div className="mt-16 flex flex-col items-center justify-center gap-8">
          <RoleplaysCallout />
          <CoachingCallout />
          <LearningPlatformCallout />
          <SecurityCallout />
        </div>
      </Container>
    </div>
  );
}
